import { FC } from 'react'

import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType } from 'src/Types/ui'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'
import { getScheduledTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/selectors'
import { selectCampaignGoalEvent } from 'src/Helpers/TagManager/TikTokVideoBasedEvents'
import {
  getIsVideosBasedOptionHidden,
  getUserId,
} from 'src/Redux/auth-process/userSlice/selectors'
import { TikTokCampaignPricingModelEnum } from 'src/Types/campaigns'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`

const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  word-break: break-all;
`
const Comment = styled(SubTitle)`
  font-weight: 400;
`

export enum CreatorTypeEnum {
  Bigger = 'Bigger',
  Smaller = 'Smaller',
}

const goalTextByPricingModel: Record<TikTokCampaignPricingModelEnum, string> = {
  [TikTokCampaignPricingModelEnum.VideosBased]:
    'Get more creators to use your sound',
  [TikTokCampaignPricingModelEnum.ViewsBased]: 'Get more video views',
  [TikTokCampaignPricingModelEnum.FollowersBased]: '',
}

export const CreatorTypeParameter: FC = () => {
  const userId = useSelector(getUserId)
  const scheduledCampaign = useSelector(getScheduledTikTokCampaign)
  const isVideosBasedOptionHidden = useSelector(getIsVideosBasedOptionHidden)
  const { setSearch } = useCustomSearchParams()
  const { pricingModel } = scheduledCampaign

  if (isVideosBasedOptionHidden) {
    return null
  }

  const handleClick = (): void => {
    setSearch({ modal: ModalType.CreatorType })
    selectCampaignGoalEvent({
      userId: String(userId),
      campaignId: Number(scheduledCampaign.id),
      campaignType: scheduledCampaign.type,
    })
  }

  if (!pricingModel) {
    return (
      <AddParameterButton onClick={handleClick}>
        <span>Select campaign goal</span>
      </AddParameterButton>
    )
  }

  return (
    <Container>
      <Wrapper>
        <SubTitle>Campaign goal</SubTitle>
        <Comment>{goalTextByPricingModel[pricingModel]}</Comment>
      </Wrapper>
      <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
    </Container>
  )
}
